import type { Plugin } from 'vue';
import { createI18n } from 'vue-i18n';
import { Locales } from './constants/Locales';
import { englishLocaleMessage } from '@/locales/loader';

export const i18nPlugin: Plugin = {
  install(vue) {
    const shouldSilenceWarnings = window.location.href.includes('/pdf') || window.location.href.includes('-pdf');

    const i18n = createI18n({
      legacy: false,
      allowComposition: true,
      locale: Locales.ENGLISH,
      fallbackLocale: Locales.ENGLISH,
      messages: {
        [Locales.ENGLISH]: englishLocaleMessage(),
      },
      missingWarn: !shouldSilenceWarnings,
      fallbackWarn: !shouldSilenceWarnings,
      silentTranslationWarn: shouldSilenceWarnings,
    });

    vue.use(i18n);
  },
};
